<template>
  <div class="practice container">
    <el-tabs
      v-model="activeName"
      type="card"
      tab-position="left"
      @tab-click="handleTabClick"
    >
      <el-tab-pane label="实战手册" name="1" v-if="info.sz">
        <div class="box">
          <el-button
            class="add-btn"
            type="danger"
            size="small"
            @click="
              $router.push({
                path: '/courseDetail/practice/practiceBank',
                query: { ...$route.query },
              })
            "
            >实战库</el-button
          >
          <el-table class="practice_list" :data="list">
            <el-table-column prop="title" label="文件名称"> </el-table-column>
            <el-table-column
              prop="taskType"
              width="100"
              label="类型"
              :formatter="formatter"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="small"
                  @click="handleDetail(scope.row)"
                >
                  {{ scope.row.taskStoreId == 0 ? "查看" : "编辑" }}
                </el-button>
                <el-button
                  @click="handleDel(scope.row.taskId)"
                  type="danger"
                  size="small"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="仿真实训" name="2" v-if="info.mock">
        <div class="box">
          <div class="pdf-box">
            <iframe class="pdf" :src="info.mockPdf"></iframe>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="直播评价" name="3" v-if="info.teamGrade" lazy>
        <div
          v-if="gradeStatus == 0"
          style="
            padding: 80px 0;
            height: calc(100vh - 60px - 59px - 60px - 60px);
          "
        >
          <empty-status
            desc="评分尚未开始，请先开启评分"
            buttonText="开始评分"
            haveButton
            @btnClick="handleStart"
          />
        </div>
        <team-grade ref="grade" v-else />
      </el-tab-pane>
      <el-tab-pane
        label="排行榜"
        name="4"
        v-if="info.teamGrade && gradeStatus == 1"
      >
        <ranking-list ref="rankingList" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getToken } from "@/utils/getToken";
import { practiceList, delPractice } from "@/api/practice";
import { mockUserList, mockBack, getMockConfig } from "@/api/chapterMock";
import { getGradeStatus, startGrade } from "@/api/teamGrade";
import teamGrade from "./teamGrade/index.vue";
import emptyStatus from "@/components/emptyStatus";
import RankingList from "./teamGrade/rankingList.vue";
import URI from "urijs";

export default {
  components: { teamGrade, emptyStatus, RankingList },
  props: {
    info: Object,
  },
  data() {
    return {
      activeName: "2",
      params: {
        title: "",
        classId: this.$route.query.id,
        classChapterId: this.$route.query.classChapterId,
        taskType: null,
      },
      list: [],
      // chapterInfo: {},
      mockUserList: [],
      gradeStatus: 0,
      mockConfig: {},
    };
  },
  activated() {
    this.getConfig();
    this.getList();
    this.getMockUserList();
    this.getStatus();
  },
  // watch: {
  //   $route(val) {
  //     this.params.classId = val.query.id;
  //     this.params.classChapterId = val.query.classChapterId;
  //     this.getList();
  //     this.getChapter();
  //     this.getMockUserList();
  //     this.getStatus();
  //   },
  // },
  methods: {
    async getConfig() {
      console.log(111);
      const res = await getMockConfig({
        classChapterId: this.$route.query.classChapterId,
      });
      console.log(res, 1);
      this.mockConfig = res.data;
    },
    //   列表
    getList() {
      this.params.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      practiceList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatter(row) {
      if (row.taskType == "PERSONAL") {
        return "个人";
      } else if (row.taskType == "TEAM") {
        return "团队";
      }
    },
    // 详情
    handleDetail(row) {
      if (row.taskStoreId == 0)
        this.$router.push({
          path: "/courseDetail/practice/pdf",
          query: { ...this.$route.query },
        });
      else
        this.$router.push({
          path: "/courseDetail/practice/detail",
          query: { ...this.$route.query, taskId: row.taskId },
        });
    },
    // 删除
    handleDel(taskId) {
      this.$confirm("确定要删除该实战吗?", {
        type: "warning",
      })
        .then(() => {
          delPractice(taskId).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleCheck(path) {
      window.open(path, "_blank");
    },

    getMockUserList() {
      mockUserList({ classChapterId: this.$route.query.classChapterId }).then(
        (res) => {
          this.mockUserList = res.data;
        }
      );
    },
    handleMockBack(resultId) {
      this.$confirm("确定要打回该学生的提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          mockBack(resultId).then((res) => {
            this.getMockUserList();
          });
        })
        .catch(() => {});
    },
    async goMock() {
      const token = await getToken();
      const reviewUrl = this.mockConfig.reviewUrl || this.mockConfig.url;
      const url = URI(reviewUrl);
      url.addQuery("token", token);
      url.addQuery("mockChapterId", this.$route.query.classChapterId);
      url.addQuery("qianchuan", 2);
      const href = url.toString();

      localStorage.setItem("mockChapterId", this.$route.query.classChapterId);

      console.log(href);
      window.open(href, "_blank");
    },
    getStatus() {
      getGradeStatus({ classChapterId: this.$route.query.classChapterId }).then(
        (res) => {
          if (res.code == 0) {
            this.gradeStatus = res.data;
          }
        }
      );
    },
    handleStart() {
      this.$confirm("确定要开启评分吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          startGrade({ classChapterId: this.$route.query.classChapterId }).then(
            (res) => {
              this.$loading.hide();
              if (res.code == 0) {
                this.$message.success("评分已开启");
                this.getStatus();
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        })
        .catch(() => {});
    },
    handleTabClick(tab) {
      if (tab.name == 2) {
        this.goMock();
      }
      if (tab.name == 4) {
        this.$refs.rankingList.getRanking();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.practice {
  margin: 30px auto;
  height: 100%;
  text-align: left;
  .box {
    padding: 20px;
    height: calc(100vh - 60px - 60px - 60px);
    background-color: #fff;
    ::v-deep .search_form {
      .el-form-item {
        margin-right: 50px;
        .el-input-group__append {
          background-color: #409eff;
          border-color: #409eff;
          color: #fff;
        }
      }
    }
    ::v-deep .practice_list {
      margin-top: 5px;
      .is-leaf {
        color: #fff;
        background-color: #f56c6c;
      }
    }

    .pdf-box {
      height: calc(100vh - 60px - 59px - 60px - 50px);
      display: flex;
      .pdf {
        flex: 1;
      }

      .right-box {
        margin-left: 10px;
        width: 200px;
        text-align: center;
      }
    }

    ::v-deep .table {
      height: calc(100vh - 60px - 59px - 60px - 50px);
      .is-leaf {
        color: #fff;
        background-color: #0088ff;
      }
    }
  }
}
</style>
